import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIHoverActionController} from './UIHoverActionController'
import {MechanicValidatorKnightActions} from '@colonist/game-mechanic-validators'
import {PlayerColor} from '@colonist/game-states'
import {logError} from '../../ui_utils/Utils'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {Sprites} from '../UIGameSprites'

export class UIKnightActionHoverActionController extends UIHoverActionController {
    private readonly knightActionValidator: MechanicValidatorKnightActions

    constructor(uiGameManager: UIGameManager, knightActionValidator: MechanicValidatorKnightActions) {
        super(uiGameManager)
        this.isCornerAction = true
        this.resources = []
        this.action = (index: number) => this.uiGameManager.socketGameSend.confirmSelectKnightToTakeAction(index)
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this)

        this.shouldHideOnSpecialBuildPhase = true
        this.knightActionValidator = knightActionValidator
    }

    protected updateState() {
        const playerColor = this.uiGameManager.gameController.myColor
        const action = this.knightActionValidator.canPlayerTakeKnightAction(playerColor)
        this.updateHoverLocations(action.validHoverLocations, action.canTakeAction)
        this.uiGameManager.mapController.hoverController.onHoverStateChange()
    }

    getTexture(index: number): PIXI.Texture {
        return UIKnightActionHoverActionController.getMoveKnightTextureForColor(this.uiGameManager.gameController.myColor, this.uiGameManager.gameController.isPlayerSpectator)
    }

    static getMoveKnightTextureForColor(playerColor: PlayerColor, isSpectator: boolean): PIXI.Texture {
        if(isSpectator) return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_green)
        switch(playerColor) {
            case PlayerColor.Blue: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_blue)
            case PlayerColor.Red: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_red)
            case PlayerColor.Orange: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_orange)
            case PlayerColor.Green: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_green)
            case PlayerColor.Bronze: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_bronze)
            case PlayerColor.Silver: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_silver)
            case PlayerColor.Gold: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_gold)
            case PlayerColor.Black: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_black)
            case PlayerColor.Purple: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_purple)
            case PlayerColor.MysticBlue: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_mysticblue)
            case PlayerColor.White: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_white)
            case PlayerColor.Pink: return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_pink)
            case PlayerColor.None: break
        }
        logError('getMoveKnightTextureForColor', [playerColor])
        return UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.knight_move_green)
    }

    // eslint-disable-next-line class-methods-use-this
    protected getBankActionAmount(index: number): number | undefined {
        return undefined
    }
}
